<cj-form-field class="flex-grow-1 w-full">
  <cj-form-label>Amount Due</cj-form-label>
  <input
    cjInput
    fullWidth
    readonly
    [value]="invoiceBalance | currency"
    [disabled]="isProcessing"
  />
</cj-form-field>
